import * as React from "react";
import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { LabWorkupList } from "./labWorkupList";
import { scrollableStyleByColor } from "fe-common/ui/commonStyles";

//region [[ Styles ]]

const SantanaPlanComponentView = styled("div")({
  display: "flex",
  flexFlow: "column",
  width: "100%",
  maxWidth: "535px",
  height: "100%",
});

const PlanBox = styled("div")({
  ...scrollableStyleByColor(KahunColorMap.AccentLightScroll),
  display: "flex",
  flexFlow: "column",

  backgroundColor: KahunColorMap.AccentLight2,
  height: `calc(100% - ${120}px)`,
  borderRadius: "25px",
});

const MainTitle = styled("span")({
  fontWeight: 700,
  fontSize: "24px",
  lineHeight: "24px",
  color: KahunColorMap.Default,

  marginBottom: "25px",
});

const SantanaLabWorkupList = styled(LabWorkupList)({
  ...scrollableStyleByColor(KahunColorMap.AccentLightScroll),
  margin: "0 -15px",
  padding: "0 15px", // replace margin with padding for scroll
  "& .plan-item": {
    background: KahunColorMap.White,
    borderRadius: "9.4px",
    boxShadow: "0px 1.1747px 9.39759px rgba(0, 0, 0, 0.12)",
  },
  "& .in-cluster": {
    borderTop: "1px solid " + KahunColorMap.AccentLight,
    boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.12)",
  },
  "& .plan-item > div": {
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  "& .plan-item .lab-test": {
    paddingTop: "0",
    paddingBottom: "0",
  },
  "& .plan-item:last-of-kind": {
    marginBottom: 0,
  },
  "& .lab-test > *": {
    flexWrap: "wrap",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface SantanaPlanComponentProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Texts ]]
const PLAN_TITLE_TEXT = "Suggested Plan";
//endregion [[ Texts ]]
export const SantanaPlan = React.memo(
  ({ ...props }: SantanaPlanComponentProps) => {
    return (
      <SantanaPlanComponentView>
        <MainTitle>{PLAN_TITLE_TEXT}</MainTitle>
        <PlanBox>
          <SantanaLabWorkupList />
        </PlanBox>
      </SantanaPlanComponentView>
    );
  },
);
